import { axios } from "helper/axios";
import { jarvisPrimeDashboardConstants } from "./jarvisPrimeDashboardConstants";

const jarvisPrimeDashboardApis = {};

jarvisPrimeDashboardApis.getPortfolioAllocations = () => {
  return axios.get(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALLOCATIONS_API,
  );
};

jarvisPrimeDashboardApis.getPortfolioOverview = () => {
  return axios.get(jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_OVERVIEW_API);
};
jarvisPrimeDashboardApis.getCustomerStoriesList = () => {
  return axios.get(jarvisPrimeDashboardConstants.CUSTOMER_STORIES_API);
};

jarvisPrimeDashboardApis.getWelcomeVideoList = () => {
  return axios.get(jarvisPrimeDashboardConstants.WELCOME_VIDEO_API);
};

jarvisPrimeDashboardApis.getPortfolioPerformance = () => {
  return axios.get(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PERFORMANCE_API,
  );
};

jarvisPrimeDashboardApis.getPortfolioChart = () => {
  let qeuryParam = `?durationOfMonth=${12}`;
  return axios.get(
    `${jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_CHART_API}${qeuryParam}`,
  );
};

jarvisPrimeDashboardApis.getPortfolioSector = () => {
  return axios.get(jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_SECTOR_API);
};

jarvisPrimeDashboardApis.getPortfolioMarket = () => {
  return axios.get(jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_MARKET_API);
};

jarvisPrimeDashboardApis.getPortfolioAlert = () => {
  return axios.post(jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALERT_API);
};

jarvisPrimeDashboardApis.getPortfolioPendingTransaction = async () => {
  return axios.post(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PENDING_TRANSACTION_API,
  );
};

jarvisPrimeDashboardApis.generateNewAction = () => {
  return axios.post(jarvisPrimeDashboardConstants.PORTFOLIO_GENERATE_API);
};

jarvisPrimeDashboardApis.primeRepairTranaction = () => {
  return axios.post(jarvisPrimeDashboardConstants.PRIME_REPAIR_TRANSACTION_API);
};

jarvisPrimeDashboardApis.porfolioArchive = ({ data }) => {
  let d = data.map((e) => ({
    action: e.action,
    actionTakenByUser: e.actionTakenByUser,
    qty: e.quantity,
    rate: e.rate,
    symbol: e.symbol,
    tracsactionType: e.tracsactionType,
  }));

  let body = {
    stockDtls: d,
  };
  return axios.post(jarvisPrimeDashboardConstants.PORTFOLIO_ARCHIVE_API, body);
};

jarvisPrimeDashboardApis.finalPortfolioConfirmation = () => {
  return axios.post(jarvisPrimeDashboardConstants.FINAL_PORTFOLIO_CONFIRMATION);
};

export { jarvisPrimeDashboardApis };
